import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FoodYesIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FoodYesIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83269 5.0603C5.44006 5.0603 5.12179 5.37858 5.12179 5.77116C5.12179 6.1638 5.44007 6.48206 5.83269 6.48206L6.89077 6.48204H10.5257C12.327 6.48204 13.8799 7.54483 14.5918 9.07754H15.8503C16.4818 9.07754 17.0508 9.3454 17.4497 9.77371C17.8488 9.34535 18.4178 9.07746 19.0493 9.07746H21.065V11.0465C21.065 11.4125 20.975 11.7574 20.816 12.0604H22.4994V13.3124C22.4994 17.6199 19.0075 21.1118 14.7001 21.1118H10.2989C5.99142 21.1118 2.49951 17.6199 2.49951 13.3124V12.0604H4.99212C5.19155 10.9202 5.96335 9.97674 7.00048 9.53717C6.56794 9.05499 6.30484 8.4177 6.30484 7.71895V7.65392L5.8327 7.65393C4.7929 7.65393 3.94992 6.81103 3.94992 5.77116C3.94992 4.73132 4.7929 3.88843 5.83269 3.88843H9.97398V5.0603H5.83269ZM9.02875 9.27098H9.1691C9.24266 9.27098 9.31566 9.27334 9.38805 9.27797V7.65391H7.47672V7.71895C7.47672 8.57612 8.1716 9.27098 9.02875 9.27098ZM10.5599 7.65409V9.56998C11.5592 10.0226 12.2988 10.9478 12.4934 12.0604H13.8346V10.9628C13.8346 9.14674 12.3716 7.67242 10.5599 7.65409ZM18.0356 12.06L18.8797 12.0599C19.4394 12.0599 19.8931 11.6062 19.8931 11.0465V10.2493H19.0493C18.4895 10.2493 18.0356 10.7032 18.0356 11.2628V12.06ZM16.8638 11.2628V12.06H16.0199C15.4602 12.06 15.0065 11.6063 15.0065 11.0466V10.2494H15.8503C16.41 10.2494 16.8638 10.7031 16.8638 11.2628ZM11.2935 12.0604C11.0371 11.1279 10.1831 10.4429 9.1691 10.4429H8.3164C7.30244 10.4429 6.44845 11.1279 6.19204 12.0604H11.2935ZM3.67139 13.2323V13.3124C3.67139 13.6842 3.702 14.0488 3.76083 14.4039H21.2381C21.2969 14.0488 21.3276 13.6842 21.3276 13.3124V13.2323H3.67139ZM20.931 15.5758H4.06792C4.99285 18.1215 7.43352 19.9399 10.2989 19.9399H14.7001C17.5654 19.9399 20.0061 18.1215 20.931 15.5758Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FoodYesIcon;
